import { GuidebookSummaryFuneralProcessContainer } from "containers/GuidebookSummaryContainer";
import { InfoPageCrmFixedCta } from "@/components/InfoPageCrmFixedCta";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  const description =
    "복잡한 장례 절차, 더 이상 헷갈리지 않도록 10년의 노하우를 담아 알려드립니다.";

  return {
    props: {
      pageDescription: description,
      pageOgTitle: "장례 절차와 일정 한눈에 보기 - [고이 장례 가이드북]",
      pageOgDescription: description,
      pageKeywords: "장례 절차, 사체검안서, 안치, 부고, 상복, 입관식, 염습, 조문, 발인, 운구",
    },
  };
};

interface Page {
  pageOgTitle: string;
}

function GuidebookSummaryFuneralProcess(_: Page) {
  return (
    <>
      <GuidebookSummaryFuneralProcessContainer />
      <InfoPageCrmFixedCta path="guidebook" />
    </>
  );
}

export default GuidebookSummaryFuneralProcess;
